// extracted by css-extract-rspack-plugin
export default {"page":"page-fpWQ_3","column":"column-eVlYfs","brand":"brand-iFMaOL","logo":"logo-o4Abpz","title":"title-CO8EyR"};